import type { JobRunOut } from '@myrentalmate/api-client';
import { Chip } from '@mui/material';

export function seconds(total: number): string {
  if (total < 60) return `${total} sec`;
  return `${Math.floor(total / 60)} min ${total % 60} sec`;
}

export function RunResult({ run }: { run: JobRunOut }) {
  if (run.stopped) return <Chip size="small" color="warning" label="Stopped" />;
  if (run.succeeded === null) return <Chip size="small" color="info" label="Running" />;
  return run.succeeded ? (
    <Chip size="small" color="success" label="Succeeded" />
  ) : (
    <Chip size="small" color="error" label="Failed" title={run.error ?? undefined} />
  );
}
